import { InjectionToken, Signal } from '@angular/core';
import { TripMember } from '../entities/person.interface';
import { PeopleService } from './people.service';
import { PeopleApi } from '../api';

export const CURRENT_TRIP_MEMBERS = new InjectionToken<Signal<TripMember[] | undefined>>(
  'CURRENT_TRIP_MEMBERS',
);

export const CurrentTripParticipantsProvider = {
  provide: CURRENT_TRIP_MEMBERS,
  useFactory: (people: PeopleService) => people.participants,
  deps: [PeopleService],
};

export const providePeople = () => [PeopleApi, CurrentTripParticipantsProvider, PeopleService];
